import {
  PropsWithChildren,
  useCallback,
  useEffect,
  useMemo,
  useReducer,
} from 'react';
import {
  ChatContext,
  ChatFilterState,
  ChatFilterStateAction,
  FILTERS_STORAGE_KEY,
  getInitialState,
} from './context';
import { ChatFilter } from '../../types/chats';

const reducer = (state: ChatFilterState, action: ChatFilterStateAction) => {
  switch (action.type) {
    case 'SET_FILTER':
      return {
        ...state,
        filter: action.payload,
      };
    case 'RESET':
      return getInitialState();

    default:
      return state;
  }
};

export function ChatProvider({ children }: PropsWithChildren) {
  const [state, dispatch] = useReducer(reducer, getInitialState());

  const contextValue = useMemo(() => ({ state, dispatch }), [state, dispatch]);

  const persist = useCallback(
    (update: Partial<ChatFilterState>) => {
      sessionStorage.setItem(
        FILTERS_STORAGE_KEY,
        JSON.stringify({
          filter: update.filter || state?.filter || ChatFilter.ALL,
        }),
      );
    },
    [state?.filter],
  );

  useEffect(() => {
    persist({ filter: state.filter });
  }, [state.filter, persist]);

  return (
    <ChatContext.Provider value={contextValue}>{children}</ChatContext.Provider>
  );
}
